<rid-klank-switch class="h-dvh" [assignments]="assignments()" (finished)="router.navigate(['mechanics/phonetic-comprehension'])" />
